import { useFlightContext } from "hooks/flight/useFlightContext";
import BookingArea from "./BookingArea";
import SideBar from "./SideBar";
import { Navigate } from "react-router-dom";
import { useEffect } from "react";
const FlightBookingArea = () => {
    const { airValidateResults } = useFlightContext();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);
    
    if (!airValidateResults) {
        return <Navigate to={"/flight-search"} />;
    }
    return (
        <>
            <section id="tour_booking_submission" className="section_padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 mb-4">
                            <BookingArea />
                        </div>
                        <div className="col-lg-4">
                            <SideBar />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default FlightBookingArea;
